import { lazy } from "react";

const SuscripcionPagar = lazy(() =>
      import("../../suscripcion/SuscripcionPagar.jsx")
);

const SuscripcionConfirmar = lazy(() =>
      import("../../suscripcion/SuscripcionConfirmar.jsx")
);

const PaymentButton = lazy(() =>
      import("../../components/payment/PaymentButton.jsx")
);

const suscripcionRoutes = [
      {
            path: "suscripcion/pagar",
            element: <SuscripcionPagar />,
      },
      {
            path: "suscripcion/confirmar-pago",
            element: <SuscripcionConfirmar />,
      },
      {
            path: "pago",
            element: <PaymentButton />,
      },
];

export default suscripcionRoutes;